import { createEvent, SpecificEvents } from "./AnalyticsEvents";
import { Organization } from "@models/Organization";
import { buildURL, SystemURL } from "@services/URLCatalog";
import { QontactUser } from "@models/QontactUser";
import { HTTPClient } from "@shared/core/HTTPClient";
import { HTTPRequest } from "@shared/core/HTTPClientInterface";


export class Analytics {
    private httpClient: HTTPClient
    private user?: QontactUser
    private selectedOrganizationID?: string

    constructor(httpClient: HTTPClient) {
        this.httpClient = httpClient
    }

    setUser(user: QontactUser) {
        this.user = user
    }

    setSelectedOrganizationID(organizationID: string) {
        this.selectedOrganizationID = organizationID
    }

    async track<T extends SpecificEvents>(event: T): Promise<void> {
        let appEvent = createEvent(
            {
                organizationID: this.selectedOrganizationID,
                userID: this.user?.id,
                source: 'web',
            },
            event
        )
        
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Analytics.postEvent, {})
        request.method = "POST";
        request.body = appEvent;
        await this.httpClient.execute(request);
    }
}